// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3HvtF","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2aM-M","obliqueLine":"membershipbadge_obliqueLine__2oXDL"};